import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IonRouterOutlet } from '@ionic/angular/standalone';
import { MenuBarComponent } from '../menu-bar/menu-bar.component';
import { TopBarComponent } from '../top-bar/top-bar.component';
import { MoreMenuComponent } from '../more-menu/more-menu.component';

@Component({
  selector: 'homi-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [
    IonRouterOutlet,
    MenuBarComponent,
    TopBarComponent,
    MoreMenuComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent {}
